// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1yHg6","sendOtp":"AuthorizeToLogin_sendOtp__1QzAy"};